import type { KAPLAYCtxT } from 'kaplay'
import { TILE_SIZE } from './consts.ts'

export function getTiledSize(tiles = 1): number {
  if (isNaN(tiles)) return 0
  else return tiles * TILE_SIZE
}

export function parsePolygon(k: KAPLAYCtxT, obj: Record<string, any>) {
  const parseData = obj.polygon.map((point: any) => k.vec2(obj.x + point.x, obj.y + point.y))
  return new k.Polygon(parseData)
}

export function getFileCacheStr(): string {
  return Math.floor(Math.random() * Date.now()).toString(36)
}
